/* src/app/components/add-edit-execution/add-set-modal/add-set-modal.component.scss */
.section-type-btn {
  margin-right: 0.5rem;
  padding: 0.875rem 1rem;
}
.rr-text {
  font-size: 0.625rem;
  line-height: 0.75rem;
  font-weight: 300;
  color: rgba(46, 46, 56, 0.64);
  margin: 0.5rem 0;
}
/*# sourceMappingURL=add-set-modal.component.css.map */
